export default __webpack_public_path__ + "static/media/Community and value growth.94214a15.jpg";